exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#rowNumber {\n  max-width: 60px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep2.vue"],"names":[],"mappings":";AAoDA;EACE,gBAAe;CAChB","file":"NewBillingTemplateStep2.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n#rowNumber {\n  max-width: 60px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2713fe24","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep2.vue
// module id = /y5w
// module chunks = 72